export default __webpack_public_path__ + "static/media/saumya.f7d03b92.jpg";